function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var makeButtonGroupStyles = function makeButtonGroupStyles(_ref) {
  var primitives = _ref.primitives,
    tokens = _ref.tokens;
  return {
    MuiButtonGroup: {
      defaultProps: {
        disableElevation: true,
        variant: "contained"
      },
      styleOverrides: {
        root: {
          '& [class*="MuiButton-root"]': _objectSpread(_objectSpread({
            alignItems: "center"
          }, tokens.transitions["state-blur"]), {}, {
            '& [class*="MuiSvgIcon-root"]': {
              height: primitives.spacings["5"],
              width: primitives.spacings["5"]
            },
            "&:hover, &:focus, &:active, &:focus-visible": _objectSpread({
              minWidth: "unset"
            }, tokens.transitions["state-activate"]),
            "&:first-of-type": {
              borderTopRightRadius: primitives.borderRadii.none,
              borderBottomRightRadius: primitives.borderRadii.none
            },
            "&:last-of-type": {
              borderTopLeftRadius: primitives.borderRadii.none,
              borderBottomLeftRadius: primitives.borderRadii.none
            },
            "&:not(:first-of-type)": {
              "&:hover, &:focus, &:active": {
                minWidth: "unset"
              }
            },
            "&:not(:last-of-type)": {
              "&:hover, &:focus, &:active": {
                minWidth: "unset"
              }
            },
            "&:not(:first-of-type):not(:last-of-type)": {
              borderRadius: primitives.borderRadii.none
            },
            '&[class*="MuiButton-sizeSmall"]': {
              padding: "5px ".concat(primitives.spacings["3"])
            },
            '&[class*="MuiButton-sizeMedium"]': {
              padding: "9px ".concat(primitives.spacings["5"])
            }
          }),
          '& [class*="MuiButtonGroup-grouped"]': {
            minWidth: "unset",
            "&:hover": {
              boxShadow: tokens.effects["halo-hover"]
            },
            "&:focus": {
              boxShadow: "0px 0px 0px 1px ".concat(primitives.colors.detail.transparent)
            },
            "&:focus:focus-visible": {
              boxShadow: "0px 0px 0px 1px ".concat(tokens.colors.background, ", 0px 0px 0px 3px ").concat(tokens.colors["ink-focus"])
            },
            "&:active, &:focus:active": {
              boxShadow: tokens.effects["halo-pressed"]
            },
            "&:not(:last-of-type):hover": {
              borderRight: "".concat(primitives.borderWidths.medium, " solid ").concat(primitives.colors.detail.transparent)
            }
          },
          '& + [class*="MuiPopper-root"]': {
            zIndex: 1,
            '& [class*="MuiPaper-root"]': {
              marginTop: primitives.spacings["1"],
              boxShadow: tokens.effects["elevation-0-popover"],
              backgroundColor: tokens.colors["fill-elevation-0"],
              '& [class*="MuiList-root"]': {
                padding: "".concat(primitives.spacings["3"], " ").concat(primitives.spacings["0"])
              }
            }
          }
        },
        contained: {
          '& [class*="MuiButton-root"]': {
            "& svg": {
              color: tokens.colors["ink-on-fill-primary"]
            },
            "&:not(:last-of-type)": {
              marginRight: "1px"
            }
          }
        },
        outlined: {
          '& [class*="MuiButton-root"]': {
            "& svg": {
              color: tokens.colors["ink-on-background"]
            },
            "&:not(:last-of-type)": {
              borderRightColor: primitives.colors.detail.transparent
            }
          }
        }
      }
    }
  };
};